import { FeedbackItem } from "../types/feedback.types";

export const formatTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

  if (diffInHours < 1) return "Just now";
  if (diffInHours < 24) return `${Math.floor(diffInHours)}h ago`;
  return date.toLocaleDateString();
};

export const stripHtmlTags = (html: string): string => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").replace(/&[a-z]+;|&#\d+;/gi, " ").trim();
};

export const createVideoUrl = (item: FeedbackItem): string | null => {
  if (item.recordingBlob) {
    return URL.createObjectURL(item.recordingBlob);
  }
  if (
    item.dataUrl &&
    (item.dataUrl.startsWith("blob:") || item.dataUrl.startsWith("data:"))
  ) {
    return item.dataUrl;
  }
  return null;
};

export const isValidVideoSource = (url: string | null): boolean => {
  if (!url) return false;
  return (
    url.startsWith("blob:") || url.startsWith("data:") || url.startsWith("http")
  );
};

export const generateVideoThumbnail = (videoUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = videoUrl;
    video.crossOrigin = "anonymous";
    video.muted = true;
    video.playsInline = true;
    video.style.cssText = "position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;";
    document.body.appendChild(video);

    const cleanup = () => {
      if (video.parentNode) video.parentNode.removeChild(video);
    };

    video.addEventListener("loadedmetadata", () => { video.currentTime = 0.5; });

    video.addEventListener("seeked", () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx) { cleanup(); reject(new Error("Canvas context unavailable")); return; }
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        cleanup();
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      } catch (err) {
        cleanup();
        reject(err);
      }
    });

    video.addEventListener("error", (e) => { cleanup(); reject(new Error("Video load error for thumbnail")); });
    video.load();
  });
};

export class AudioConverter {
  static async convertToMP3(inputBlob: Blob): Promise<Blob> {
    try {
      if (inputBlob.type.includes("mp3") || inputBlob.type.includes("mpeg")) {
        return inputBlob;
      }
      const mp3Blob = new Blob([inputBlob], { type: "audio/mp3" });
      return mp3Blob;
    } catch (error) {
      return new Blob([inputBlob], { type: "audio/mp3" });
    }
  }
}
